"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var Collection_1 = __importDefault(require("../Collection"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var MobileGames = function (_a) {
    var preparedCollections = _a.preparedCollections;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement(ui_components_1.TopBar, { title: t('gamesByTheme'), showNavigationButtons: false, linkAddress: null }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.slide, style: {
                    gridTemplateColumns: "repeat(".concat(preparedCollections.length, ", 1fr)"),
                    // width: breakpoints.mobile
                    //   ? `calc(42.5%*${preparedCollections.length} - 10% + 6px)`
                    //   : 'width: calc(170% + 9px)',
                } }, preparedCollections === null || preparedCollections === void 0 ? void 0 : preparedCollections.map(function (item, idx) { return (react_1.default.createElement(Collection_1.default, __assign({ key: "gamesSetCollectionsMobile".concat(idx) }, item))); })))));
};
exports.default = MobileGames;
